import React from 'react';

import {
  clubsFiltersQuery,
  clubsAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';
import { FundsSecondaryInfo } from '../funds/components/SecondaryInfo';

import { tableHead } from './constants';
import ProductItem from './item';

export const ClubesTable = (props: DynamicAssetTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={clubsAssetsQuery}
      filtersQuery={clubsFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={4}
      tabletSecondaryInfo={FundsSecondaryInfo}
      mobileSecondaryInfo={FundsSecondaryInfo}
      mobileColumns={2}
      mobileRows={2}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'productTypeNormalized', label: 'Tipo' },
        { key: 'positionDateNormalized', label: 'Data da posição' },
        { key: 'valueNormalized', label: 'Valor' },
        { key: 'variationNormalized', label: 'Variação', coloredField: 'variationType' },
      ]}
    />
  );
};
